'use client';

import { CagrResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: CagrResult;
  translations: ToolsTranslations['cagr'];
  startingAmount: number;
  endingAmount: number;
  years: number;
  currency: string;
}


export default function ResultsDisplay({ result, translations, startingAmount, endingAmount, years, currency }: ResultsDisplayProps) {
  const percentage = result.cagr !== null ? (result.cagr * 100) : null;
  const totalReturn = Math.max(0, Math.round(endingAmount - startingAmount));
  const annualReturn = years > 0 ? Math.round(totalReturn / years) : 0;

  return (
    <div className="space-y-3">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultLabel}</div>
        <div className="text-3xl font-bold text-blue-900">
          {percentage !== null ? `${percentage.toFixed(2)}%` : '—'}
        </div>
        {!result.isValid && (
          <div className="text-xs text-red-600 mt-2">
            {result.message ?? translations.invalid.generic}
          </div>
        )}
      </div>
      
      {/* Additional Information Box */}
      {result.isValid && result.cagr !== null && (
        <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
          <p className="text-sm font-medium text-gray-700 mb-3"><b>{translations.additionalInfo.title}</b></p>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <p className="text-gray-600">{translations.additionalInfo.totalGrowth}:</p>
              <p className="font-semibold text-gray-800">{totalReturn.toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}</p>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{translations.additionalInfo.annualGrowth}:</span>
              <span className="font-semibold text-gray-800">
                {annualReturn.toLocaleString(process.env.NEXT_PUBLIC_WEBSITE_LOCALE || 'sv-SE')} {currency}
              </span>
            </div>
          </div>
        </div>
      )}
      
      <p className="text-xs text-gray-500">{translations.formulaNote}</p>
    </div>
  );
}


